// Calcul des dates de livraison estimées et gestion des modaux
document.addEventListener('DOMContentLoaded', function() {
  // Calcul des dates de livraison estimées
  function getISODate(date) {
    function z(n) { return (n < 10 ? '0' : '') + n; }
    return date.getFullYear() + '-' + z(date.getMonth() + 1) + '-' + z(date.getDate());
  }

  function addWorkingDays(startDate, numberOfDays) {
    let date = new Date(startDate.getTime());
    while (numberOfDays > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() % 6 !== 0) { // Exclut samedi et dimanche
        numberOfDays--;
      }
    }
    return date;
  }

  const d = new Date();
  const options = { weekday: "long", month: "long", day: "2-digit" };
  const JourUn = addWorkingDays(d, 2).toLocaleDateString("fr-FR", options);
  const JourDeux = addWorkingDays(d, 3).toLocaleDateString("fr-FR", options);

  const elementLivraison = document.getElementById("livraison");
  if (elementLivraison) {
    elementLivraison.innerHTML = JourUn + " et le " + JourDeux;
  }

  // Bouton Taille état actif
  const sizeLabelSpan = document.querySelector('.text-subdued');
  if (sizeLabelSpan && sizeLabelSpan.nextElementSibling) {
    const sizeInfoContent = sizeLabelSpan.nextElementSibling.textContent;
    
    if (sizeInfoContent.includes('cabine')) {
      document.querySelector('#boutonCabine').classList.add('active');
    }
    if (sizeInfoContent.includes('cabine plus')) {
      document.querySelector('#boutonCabinePlus').classList.add('active');
    }
    if (sizeInfoContent.includes('medium')) {
      document.querySelector('#boutonMedium').classList.add('active');
    }
    if (sizeInfoContent.includes('large')) {
      document.querySelector('#boutonLarge').classList.add('active');
    }
  }
});

window.onload = function() {
    const productSKU = document.getElementById('product-sku') ? document.getElementById('product-sku').textContent.trim() : "";

    function updateButtonStates(sku) {
        document.querySelectorAll('.size-button').forEach(button => button.classList.remove('active'));

        if (sku.includes("553520") && document.querySelector('#boutonCabine')) {
            document.querySelector('#boutonCabine').classList.add('active');
        } else if (sku.includes("554020") && document.querySelector('#boutonCabinePlus')) {
            document.querySelector('#boutonCabinePlus').classList.add('active');
        } else if (sku.includes("664827") && document.querySelector('#boutonMedium')) {
            document.querySelector('#boutonMedium').classList.add('active');
        } else if (sku.includes("765531") && document.querySelector('#boutonLarge')) {
            document.querySelector('#boutonLarge').classList.add('active');
        }

        if (sku.includes("-") && document.querySelector('#boutonAvecPochettes')) {
            document.querySelector('#boutonAvecPochettes').classList.add('active');
        } else if (document.querySelector('#boutonSansPochette')) {
            document.querySelector('#boutonSansPochette').classList.add('active');
        }
    }

    updateButtonStates(productSKU);

    document.addEventListener('change', function(event) {
    if (event.target.matches('.variant-picker__option-values input[type="radio"]')) {
        const updatedSKU = document.getElementById('product-sku').textContent.trim();
        updateButtonStates(updatedSKU);
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
    function updateButtonStates(sku) {
        if (sku.includes("EDOTS01")) {
            document.querySelector('#boutonPochCabine').classList.add('active');
        } else if (sku.includes("EDOTSXL")) {
            document.querySelector('#boutonPochCabinePlus').classList.add('active');
        } else if (sku.includes("EDOTM")) {
            document.querySelector('#boutonPochMedium').classList.add('active');
        } else if (sku.includes("EDOTL")) {
            document.querySelector('#boutonPochLarge').classList.add('active');
        }
    }

    const productSKU = document.getElementById('product-sku') ? document.getElementById('product-sku').textContent.trim() : "";
    updateButtonStates(productSKU);

    document.addEventListener('change', function(event) {
        if (event.target.matches('.variant-picker__option-values input[type="radio"]')) {
            const updatedSKU = document.getElementById('product-sku').textContent.trim();
            updateButtonStates(updatedSKU);
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    function updateButtonStates(sku) {
        if (sku.includes("EDOTS")) {
            document.querySelector('#boutonDotCabine').classList.add('active');
        } else if (sku.includes("EDOTM")) {
            document.querySelector('#boutonDotMedium').classList.add('active');
        } else if (sku.includes("EDOTL")) {
            document.querySelector('#boutonDotLarge').classList.add('active');
        }
    }

    const productSKU = document.getElementById('product-sku') ? document.getElementById('product-sku').textContent.trim() : "";
    updateButtonStates(productSKU);

    document.addEventListener('change', function(event) {
        if (event.target.matches('.variant-picker__option-values input[type="radio"]')) {
            const updatedSKU = document.getElementById('product-sku').textContent.trim();
            updateButtonStates(updatedSKU);
        }
    });
});

window.addEventListener('loadPopup', function() {
    globalModal();
});

function globalModal() {
    document.querySelectorAll('[data-modal-target]').forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault(); // Empêche le comportement par défaut
            const modalId = this.getAttribute('data-modal-target');
            console.log(modalId);
            const modal = document.getElementById(modalId);
            console.log(modal);
            modal.style.display = 'block'; // Affiche le modal
            document.querySelector('.modal-overlay').style.display = 'block'; // Affiche l'overlay
        });
    });

    // Fermer les modals au clic sur le bouton fermer
    document.querySelectorAll('.close_multi').forEach(button => {
        button.addEventListener('click', function() {
            const modal = this.closest('.modal_multi');
            if (modal) {
                modal.style.display = 'none'; // Masque le modal
            }
            document.querySelector('.modal-overlay').style.display = 'none'; // Masque l'overlay
        });
    });

    // Fermer les modals au clic sur l'overlay
    document.querySelector('.modal-overlay').addEventListener('click', function() {
        const modalsOpen = document.querySelectorAll('.modal_multi');
        modalsOpen.forEach(modal => {
            modal.style.display = 'none'; // Masque le modal
        });
        this.style.display = 'none'; // Masque l'overlay
    });
}

document.addEventListener('DOMContentLoaded', function() {
    globalModal();
});

// Sticky bundle : declenchement des que le titre "Taille :" est sorti (boutons encore visibles)
  (function () {
    var ticking = false;

    function update() {
      ticking = false;
      var bar = document.querySelector('.product-sticky-bundle');
      if (!bar) return;
      var sizes = document.querySelector('#button-suitcase-size-container');
      if (!sizes) { bar.classList.remove('is-visible'); return; }
      // Le titre "Taille :" est juste au-dessus du conteneur de boutons.
      // Des que le haut du conteneur franchit le haut de l'ecran, le titre est sorti
      // alors que les boutons restent visibles.
      var passed = sizes.getBoundingClientRect().top < 40;
      bar.classList.toggle('is-visible', passed);
    }
  
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('DOMContentLoaded', update);

    // La barre et le selecteur sont re-rendus a chaque changement de variant
    document.body.addEventListener('product:rerender', function () {
      requestAnimationFrame(update);
    }, true);
  })();

